import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { LOGIN_USER, LOGOUT_USER, RESET_PASSWORD } from '../actions';

import {
  loginUserSuccess,
  loginUserError,
  resetPasswordSuccess,
  resetPasswordError,
} from './actions';

import { adminRoot } from '../../constants/defaultValues';
import { withPostPutDeleteAsync } from '../api';

const loginWithEmailPasswordAsync = (email, password) =>
  withPostPutDeleteAsync({
    query: 'api/user/login',
    body: {
      email,
      password,
    },
    method: 'POST',
  })
    .then((response) => response.json())
    .then((user) => user)
    .catch((error) => error);

function* loginWithEmailPassword({ payload }) {
  const { email, password } = payload.user;
  const { history } = payload;
  try {
    const loginUser = yield call(loginWithEmailPasswordAsync, email, password);
    if (!loginUser.message) {
      yield put(loginUserSuccess(loginUser));
      history.push(adminRoot);
    } else {
      yield put(loginUserError(loginUser.message));
    }
  } catch (error) {
    yield put(loginUserError(error));
  }
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

const logoutAsync = async (payload) => {
  await new Promise((resolve) => {
    resolve(payload);
  });
  window.location.reload();
};

function* logout({ payload }) {
  yield call(logoutAsync, payload);
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

const resetPasswordAsync = async (resetPasswordCode, newPassword) => {
  return new Promise((resolve) => {
    resolve({
      resetPasswordCode,
      newPassword,
    });
  });
};

function* resetPassword({ payload }) {
  const { newPassword, resetPasswordCode } = payload;
  try {
    const resetPasswordStatus = yield call(
      resetPasswordAsync,
      resetPasswordCode,
      newPassword
    );
    if (!resetPasswordStatus) {
      yield put(resetPasswordSuccess('success'));
    } else {
      yield put(resetPasswordError(resetPasswordStatus.message));
    }
  } catch (error) {
    yield put(resetPasswordError(error));
  }
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchResetPassword),
  ]);
}
